<template>
  <div class="col q-gutter-y-sm q-px-sm">
    <div
      v-for="(metadataFilter, index) in modelValue"
      :key="index"
      class="row q-gutter-sm items-center"
    >
      <q-select
        v-model="metadataFilter.key"
        :options="metadataKeys"
        dense
        filled
        style="width: 200px"
        label="Metadata Field"
      />
      <q-select
        v-model="metadataFilter.logic"
        :options="metadataLogicOptions"
        dense
        filled
        style="width: 120px"
        label="Comparison"
      />
      <q-input v-model="metadataFilter.value" dense filled style="width: 200px" label="Value" />
      <q-icon name="close" class="cursor-pointer text-grey-6" @click="removeFilter(index)" />
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

type MetadataLogicOptions = 'contains' | '=' | '<' | '>' | '<=' | '>='
interface MetadataFilter {
  key: string | null
  value: string | number | boolean | null
  logic: MetadataLogicOptions
}

export default {
  name: 'MetadataFilters',
  props: {
    modelValue: {
      type: Array as PropType<MetadataFilter[]>,
      required: true
    },
    metadataKeys: {
      type: Array as PropType<string[]>,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      metadataLogicOptions: ['contains', '=', '<', '>', '<=', '>='] as MetadataLogicOptions[]
    }
  },
  methods: {
    removeFilter(index: number) {
      const updatedFilters = [...this.modelValue]
      updatedFilters.splice(index, 1)
      this.$emit('update:modelValue', updatedFilters)
    }
  }
}
</script>
